import React from 'react'
import { connect } from 'react-redux';
import * as AppActions from '../actions/AppActions';
import CustomForm from './CustomForm'
import OTP from '../ReduxFormFields/OTP'
import LoginHeaderText from './LoginHeaderText'
import HeaderImage from './HeaderImage';
import { formValueSelector } from 'redux-form';
import LableWithLoader from './LabelWithLoader';
import {
  required,
  mobile
} from '../utilities/fieldValidate'
import CountTimer from './CountTimer';

const selector = formValueSelector('login')
const forgotSelector = formValueSelector('mobile_form');

function mapStateToProps(state) {
  return {
    mobile: selector(state, 'mobile'),
    mobileRecovery:forgotSelector(state,'mobile'),
    isLoading: state.login.isLoading,
    hasError: state.login.hasError,
  };
}

class ConfirmOTP extends React.Component {

  submit = values => {
    let payloadMobile;
    //comparing the mobile fields of two forms 'login' and 'forgot_password' 
    //to know from where the user is coming and picking up the correct value
    if (required(this.props.mobile) || mobile(this.props.mobile)) {
      payloadMobile=this.props.mobileRecovery
    }
    else{
      payloadMobile=this.props.mobile
    }

      let data = {
        mobile: payloadMobile,
        otp:values.otp
      }
      this.props.fetchLoginDetails(data)
  }

  editClick = () => {
    // console.log('edit',this.props.history)
    this.props.history.goBack();
  }

  componentWillUnmount() {
    //to reset the error and isLoading state   
    this.props.resetState()
  }
  
  resendOTP = () => {
     let payloadMobile;
     //comparing the mobile fields of two forms 'login' and 'forgot_password' 
     //to know from where the user is coming and picking up the correct value
     if (required(this.props.mobile) || mobile(this.props.mobile)) {
       payloadMobile=this.props.mobileRecovery
     }
     else{
       payloadMobile=this.props.mobile
     }
    let data = {
      mobile:payloadMobile,
      type: 1
    }
    this.props.resendOTP(data)
  }

  render() {

    let err = !this.props.isLoading ? this.props.hasError : null

    return (
      <div>
        <HeaderImage />
        <div className='container-fluid'>
          <CustomForm
            form_name='change_password'
            destroy={true}
            isLoading={this.props.isLoading}
            onSubmit={this.submit}
            err={err}
            label={
              <LableWithLoader
                text='Confirm'
                loader={this.props.isLoading}
              />
            }
          >
            <LoginHeaderText />
            <OTP editClick={this.editClick} />
            <CountTimer
            isLoading={this.props.isLoading}
            resendOtpNum = {this.resendOTP}
            />
          </CustomForm>
        </div>
      </div>
    );
  }

}

export default connect(mapStateToProps, {
  ...AppActions
})(ConfirmOTP);



// WEBPACK FOOTER //
// ./src/components/ConfirmOTP.js